import { render, staticRenderFns } from "./AreadetailModel.vue?vue&type=template&id=08b3ea88&scoped=true"
import script from "./AreadetailModel.vue?vue&type=script&lang=js"
export * from "./AreadetailModel.vue?vue&type=script&lang=js"
import style0 from "./AreadetailModel.vue?vue&type=style&index=0&id=08b3ea88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3ea88",
  null
  
)

export default component.exports